export default "__VITE_ASSET__B3BGRD1___"